import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translatePart'
})
export class PartEditHistoryTranslatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: string): string {
    if (!value) return '';

    const words = value.split(' ');
    const translatedWords = words.map(word => {
      const translatedWord = this.translate.instant(`HistoryEditTranslate.${word}`);
      return translatedWord === `HistoryEditTranslate.${word}` ? word : translatedWord; 
    });

    console.log('words',words, 'translatedWords',translatedWords);
    

    return translatedWords.join(' ');
  }
}